export default __webpack_public_path__ + "static/assets/med_gel_solid_03_f.0594ea39.png";